module.exports = __webpack_public_path__ + "static/img/7.c92b6e82.png";